/**
 * Форматує номер телефону за маскою +380 XX XXX XX XX
 * @param phone - Номер телефону у будь-якому форматі
 * @returns Форматований номер телефону
 */
export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return "";

  // Видаляємо всі нецифрові символи окрім +
  let cleaned = phone.replace(/[^\d+]/g, "");

  // Видаляємо + якщо він не на початку
  if (cleaned.includes("+")) {
    const plusIndex = cleaned.indexOf("+");
    if (plusIndex > 0) {
      cleaned = "+" + cleaned.replace(/\+/g, "");
    }
  }

  // Якщо номер починається з 0380 або 380, замінюємо на +380
  if (cleaned.startsWith("0380")) {
    cleaned = "+" + cleaned.substring(1);
  } else if (cleaned.startsWith("380") && !cleaned.startsWith("+")) {
    cleaned = "+" + cleaned;
  } else if (cleaned.startsWith("0") && !cleaned.startsWith("0380")) {
    // Якщо починається з 0, замінюємо на +380
    cleaned = "+380" + cleaned.substring(1);
  }

  // Якщо номер не починається з +380, додаємо
  if (!cleaned.startsWith("+380")) {
    // Видаляємо всі символи окрім цифр
    const digitsOnly = cleaned.replace(/\D/g, "");
    // Якщо це 9 цифр (без коду країни), додаємо +380
    if (digitsOnly.length === 9) {
      cleaned = "+380" + digitsOnly;
    } else if (digitsOnly.length === 10) {
      // Якщо 10 цифр, припускаємо що це 0XXXXXXXXX
      cleaned = "+380" + digitsOnly.substring(1);
    }
  }

  // Форматуємо за маскою +380 XX XXX XX XX
  const match = cleaned.match(/^(\+380)(\d{2})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]}`;
  }

  // Якщо не відповідає маску, повертаємо очищене число
  return cleaned;
};

/**
 * Витягує чистий номер телефону без форматування (для tel: посилання)
 * @param phone - Номер телефону у будь-якому форматі
 * @returns Чистий номер у форматі +380...
 */
export const getCleanPhoneNumber = (phone: string): string => {
  if (!phone) return "";

  let cleaned = phone.replace(/[^\d+]/g, "");

  // Якщо починається з 0380, замінюємо на +380
  if (cleaned.startsWith("0380")) {
    cleaned = "+" + cleaned.substring(1);
  } else if (cleaned.startsWith("380") && !cleaned.startsWith("+")) {
    cleaned = "+" + cleaned;
  } else if (cleaned.startsWith("0") && !cleaned.startsWith("0380")) {
    cleaned = "+380" + cleaned.substring(1);
  }

  // Якщо номер не починається з +380, додаємо
  if (!cleaned.startsWith("+380")) {
    const digitsOnly = cleaned.replace(/\D/g, "");
    if (digitsOnly.length === 9) {
      cleaned = "+380" + digitsOnly;
    } else if (digitsOnly.length === 10) {
      cleaned = "+380" + digitsOnly.substring(1);
    }
  }

  return cleaned;
};
